export default "__VITE_ASSET__CtSs_ft6__"